import { render, staticRenderFns } from "./DataAnalysis.vue?vue&type=template&id=bb921634&scoped=true&"
import script from "./DataAnalysis.vue?vue&type=script&lang=js&"
export * from "./DataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalysis.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DataAnalysis.vue?vue&type=style&index=1&id=bb921634&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb921634",
  null
  
)

export default component.exports